import Header from './Header'

export default Header



// WEBPACK FOOTER //
// ./src/components/Header/index.js